/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as OrderFlowLabsRouteImport } from './routes/order-flow-labs'
import { Route as MarketplaceRouteImport } from './routes/marketplace'
import { Route as LoginRouteImport } from './routes/login'
import { Route as EducationRouteImport } from './routes/education'
import { Route as DevelopersRouteImport } from './routes/developers'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as BasePayDemoRouteImport } from './routes/base-pay-demo'
import { Route as BacktestingRouteImport } from './routes/backtesting'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DeveloperSubmitRouteImport } from './routes/developer/submit'
import { Route as DashboardBacktestsRouteImport } from './routes/dashboard.backtests'
import { Route as DashboardAlgorithmsRouteImport } from './routes/dashboard.algorithms'
import { Route as AlgorithmSlugRouteImport } from './routes/algorithm/$slug'
import { Route as DashboardBacktestsNewRouteImport } from './routes/dashboard.backtests.new'
import { Route as DashboardBacktestsIdRouteImport } from './routes/dashboard.backtests.$id'
import { Route as DashboardAlgorithmsNewRouteImport } from './routes/dashboard.algorithms.new'
import { Route as DashboardAlgorithmsIdRouteImport } from './routes/dashboard.algorithms.$id'

const ResourcesRoute = ResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const OrderFlowLabsRoute = OrderFlowLabsRouteImport.update({
  id: '/order-flow-labs',
  path: '/order-flow-labs',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketplaceRoute = MarketplaceRouteImport.update({
  id: '/marketplace',
  path: '/marketplace',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const EducationRoute = EducationRouteImport.update({
  id: '/education',
  path: '/education',
  getParentRoute: () => rootRouteImport,
} as any)
const DevelopersRoute = DevelopersRouteImport.update({
  id: '/developers',
  path: '/developers',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const BasePayDemoRoute = BasePayDemoRouteImport.update({
  id: '/base-pay-demo',
  path: '/base-pay-demo',
  getParentRoute: () => rootRouteImport,
} as any)
const BacktestingRoute = BacktestingRouteImport.update({
  id: '/backtesting',
  path: '/backtesting',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const DeveloperSubmitRoute = DeveloperSubmitRouteImport.update({
  id: '/developer/submit',
  path: '/developer/submit',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardBacktestsRoute = DashboardBacktestsRouteImport.update({
  id: '/backtests',
  path: '/backtests',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAlgorithmsRoute = DashboardAlgorithmsRouteImport.update({
  id: '/algorithms',
  path: '/algorithms',
  getParentRoute: () => DashboardRoute,
} as any)
const AlgorithmSlugRoute = AlgorithmSlugRouteImport.update({
  id: '/algorithm/$slug',
  path: '/algorithm/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardBacktestsNewRoute = DashboardBacktestsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => DashboardBacktestsRoute,
} as any)
const DashboardBacktestsIdRoute = DashboardBacktestsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => DashboardBacktestsRoute,
} as any)
const DashboardAlgorithmsNewRoute = DashboardAlgorithmsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => DashboardAlgorithmsRoute,
} as any)
const DashboardAlgorithmsIdRoute = DashboardAlgorithmsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => DashboardAlgorithmsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/backtesting': typeof BacktestingRoute
  '/base-pay-demo': typeof BasePayDemoRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/developers': typeof DevelopersRoute
  '/education': typeof EducationRoute
  '/login': typeof LoginRoute
  '/marketplace': typeof MarketplaceRoute
  '/order-flow-labs': typeof OrderFlowLabsRoute
  '/register': typeof RegisterRoute
  '/resources': typeof ResourcesRoute
  '/algorithm/$slug': typeof AlgorithmSlugRoute
  '/dashboard/algorithms': typeof DashboardAlgorithmsRouteWithChildren
  '/dashboard/backtests': typeof DashboardBacktestsRouteWithChildren
  '/developer/submit': typeof DeveloperSubmitRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/algorithms/$id': typeof DashboardAlgorithmsIdRoute
  '/dashboard/algorithms/new': typeof DashboardAlgorithmsNewRoute
  '/dashboard/backtests/$id': typeof DashboardBacktestsIdRoute
  '/dashboard/backtests/new': typeof DashboardBacktestsNewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/backtesting': typeof BacktestingRoute
  '/base-pay-demo': typeof BasePayDemoRoute
  '/developers': typeof DevelopersRoute
  '/education': typeof EducationRoute
  '/login': typeof LoginRoute
  '/marketplace': typeof MarketplaceRoute
  '/order-flow-labs': typeof OrderFlowLabsRoute
  '/register': typeof RegisterRoute
  '/resources': typeof ResourcesRoute
  '/algorithm/$slug': typeof AlgorithmSlugRoute
  '/dashboard/algorithms': typeof DashboardAlgorithmsRouteWithChildren
  '/dashboard/backtests': typeof DashboardBacktestsRouteWithChildren
  '/developer/submit': typeof DeveloperSubmitRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/algorithms/$id': typeof DashboardAlgorithmsIdRoute
  '/dashboard/algorithms/new': typeof DashboardAlgorithmsNewRoute
  '/dashboard/backtests/$id': typeof DashboardBacktestsIdRoute
  '/dashboard/backtests/new': typeof DashboardBacktestsNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/backtesting': typeof BacktestingRoute
  '/base-pay-demo': typeof BasePayDemoRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/developers': typeof DevelopersRoute
  '/education': typeof EducationRoute
  '/login': typeof LoginRoute
  '/marketplace': typeof MarketplaceRoute
  '/order-flow-labs': typeof OrderFlowLabsRoute
  '/register': typeof RegisterRoute
  '/resources': typeof ResourcesRoute
  '/algorithm/$slug': typeof AlgorithmSlugRoute
  '/dashboard/algorithms': typeof DashboardAlgorithmsRouteWithChildren
  '/dashboard/backtests': typeof DashboardBacktestsRouteWithChildren
  '/developer/submit': typeof DeveloperSubmitRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/algorithms/$id': typeof DashboardAlgorithmsIdRoute
  '/dashboard/algorithms/new': typeof DashboardAlgorithmsNewRoute
  '/dashboard/backtests/$id': typeof DashboardBacktestsIdRoute
  '/dashboard/backtests/new': typeof DashboardBacktestsNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/backtesting'
    | '/base-pay-demo'
    | '/dashboard'
    | '/developers'
    | '/education'
    | '/login'
    | '/marketplace'
    | '/order-flow-labs'
    | '/register'
    | '/resources'
    | '/algorithm/$slug'
    | '/dashboard/algorithms'
    | '/dashboard/backtests'
    | '/developer/submit'
    | '/dashboard/'
    | '/dashboard/algorithms/$id'
    | '/dashboard/algorithms/new'
    | '/dashboard/backtests/$id'
    | '/dashboard/backtests/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/backtesting'
    | '/base-pay-demo'
    | '/developers'
    | '/education'
    | '/login'
    | '/marketplace'
    | '/order-flow-labs'
    | '/register'
    | '/resources'
    | '/algorithm/$slug'
    | '/dashboard/algorithms'
    | '/dashboard/backtests'
    | '/developer/submit'
    | '/dashboard'
    | '/dashboard/algorithms/$id'
    | '/dashboard/algorithms/new'
    | '/dashboard/backtests/$id'
    | '/dashboard/backtests/new'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/backtesting'
    | '/base-pay-demo'
    | '/dashboard'
    | '/developers'
    | '/education'
    | '/login'
    | '/marketplace'
    | '/order-flow-labs'
    | '/register'
    | '/resources'
    | '/algorithm/$slug'
    | '/dashboard/algorithms'
    | '/dashboard/backtests'
    | '/developer/submit'
    | '/dashboard/'
    | '/dashboard/algorithms/$id'
    | '/dashboard/algorithms/new'
    | '/dashboard/backtests/$id'
    | '/dashboard/backtests/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  BacktestingRoute: typeof BacktestingRoute
  BasePayDemoRoute: typeof BasePayDemoRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  DevelopersRoute: typeof DevelopersRoute
  EducationRoute: typeof EducationRoute
  LoginRoute: typeof LoginRoute
  MarketplaceRoute: typeof MarketplaceRoute
  OrderFlowLabsRoute: typeof OrderFlowLabsRoute
  RegisterRoute: typeof RegisterRoute
  ResourcesRoute: typeof ResourcesRoute
  AlgorithmSlugRoute: typeof AlgorithmSlugRoute
  DeveloperSubmitRoute: typeof DeveloperSubmitRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/resources': {
      id: '/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof ResourcesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order-flow-labs': {
      id: '/order-flow-labs'
      path: '/order-flow-labs'
      fullPath: '/order-flow-labs'
      preLoaderRoute: typeof OrderFlowLabsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketplace': {
      id: '/marketplace'
      path: '/marketplace'
      fullPath: '/marketplace'
      preLoaderRoute: typeof MarketplaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/education': {
      id: '/education'
      path: '/education'
      fullPath: '/education'
      preLoaderRoute: typeof EducationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/developers': {
      id: '/developers'
      path: '/developers'
      fullPath: '/developers'
      preLoaderRoute: typeof DevelopersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/base-pay-demo': {
      id: '/base-pay-demo'
      path: '/base-pay-demo'
      fullPath: '/base-pay-demo'
      preLoaderRoute: typeof BasePayDemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/backtesting': {
      id: '/backtesting'
      path: '/backtesting'
      fullPath: '/backtesting'
      preLoaderRoute: typeof BacktestingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/developer/submit': {
      id: '/developer/submit'
      path: '/developer/submit'
      fullPath: '/developer/submit'
      preLoaderRoute: typeof DeveloperSubmitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/backtests': {
      id: '/dashboard/backtests'
      path: '/backtests'
      fullPath: '/dashboard/backtests'
      preLoaderRoute: typeof DashboardBacktestsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/algorithms': {
      id: '/dashboard/algorithms'
      path: '/algorithms'
      fullPath: '/dashboard/algorithms'
      preLoaderRoute: typeof DashboardAlgorithmsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/algorithm/$slug': {
      id: '/algorithm/$slug'
      path: '/algorithm/$slug'
      fullPath: '/algorithm/$slug'
      preLoaderRoute: typeof AlgorithmSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/backtests/new': {
      id: '/dashboard/backtests/new'
      path: '/new'
      fullPath: '/dashboard/backtests/new'
      preLoaderRoute: typeof DashboardBacktestsNewRouteImport
      parentRoute: typeof DashboardBacktestsRoute
    }
    '/dashboard/backtests/$id': {
      id: '/dashboard/backtests/$id'
      path: '/$id'
      fullPath: '/dashboard/backtests/$id'
      preLoaderRoute: typeof DashboardBacktestsIdRouteImport
      parentRoute: typeof DashboardBacktestsRoute
    }
    '/dashboard/algorithms/new': {
      id: '/dashboard/algorithms/new'
      path: '/new'
      fullPath: '/dashboard/algorithms/new'
      preLoaderRoute: typeof DashboardAlgorithmsNewRouteImport
      parentRoute: typeof DashboardAlgorithmsRoute
    }
    '/dashboard/algorithms/$id': {
      id: '/dashboard/algorithms/$id'
      path: '/$id'
      fullPath: '/dashboard/algorithms/$id'
      preLoaderRoute: typeof DashboardAlgorithmsIdRouteImport
      parentRoute: typeof DashboardAlgorithmsRoute
    }
  }
}

interface DashboardAlgorithmsRouteChildren {
  DashboardAlgorithmsIdRoute: typeof DashboardAlgorithmsIdRoute
  DashboardAlgorithmsNewRoute: typeof DashboardAlgorithmsNewRoute
}

const DashboardAlgorithmsRouteChildren: DashboardAlgorithmsRouteChildren = {
  DashboardAlgorithmsIdRoute: DashboardAlgorithmsIdRoute,
  DashboardAlgorithmsNewRoute: DashboardAlgorithmsNewRoute,
}

const DashboardAlgorithmsRouteWithChildren =
  DashboardAlgorithmsRoute._addFileChildren(DashboardAlgorithmsRouteChildren)

interface DashboardBacktestsRouteChildren {
  DashboardBacktestsIdRoute: typeof DashboardBacktestsIdRoute
  DashboardBacktestsNewRoute: typeof DashboardBacktestsNewRoute
}

const DashboardBacktestsRouteChildren: DashboardBacktestsRouteChildren = {
  DashboardBacktestsIdRoute: DashboardBacktestsIdRoute,
  DashboardBacktestsNewRoute: DashboardBacktestsNewRoute,
}

const DashboardBacktestsRouteWithChildren =
  DashboardBacktestsRoute._addFileChildren(DashboardBacktestsRouteChildren)

interface DashboardRouteChildren {
  DashboardAlgorithmsRoute: typeof DashboardAlgorithmsRouteWithChildren
  DashboardBacktestsRoute: typeof DashboardBacktestsRouteWithChildren
  DashboardIndexRoute: typeof DashboardIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAlgorithmsRoute: DashboardAlgorithmsRouteWithChildren,
  DashboardBacktestsRoute: DashboardBacktestsRouteWithChildren,
  DashboardIndexRoute: DashboardIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  BacktestingRoute: BacktestingRoute,
  BasePayDemoRoute: BasePayDemoRoute,
  DashboardRoute: DashboardRouteWithChildren,
  DevelopersRoute: DevelopersRoute,
  EducationRoute: EducationRoute,
  LoginRoute: LoginRoute,
  MarketplaceRoute: MarketplaceRoute,
  OrderFlowLabsRoute: OrderFlowLabsRoute,
  RegisterRoute: RegisterRoute,
  ResourcesRoute: ResourcesRoute,
  AlgorithmSlugRoute: AlgorithmSlugRoute,
  DeveloperSubmitRoute: DeveloperSubmitRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
